import React from "react";
import useSWR, { mutate } from "swr";
import { PageHeader } from "@/components/app/PageHeader";
import { ClientFormDialog } from "@/components/app/ClientFormDialog";
import { EnrichDialog } from "@/components/app/EnrichDialog";
import { api } from "@/lib/api";

const fetcher = (u) => api.get(u).then((r) => r.data);

function EnrichBadge({ c }) {
  const e = c.enrichment;
  if (e?.status === "enriched") {
    return <span className="text-xs px-2 py-0.5 rounded-full border bg-emerald-50 text-emerald-700 border-emerald-200" data-testid={`enrich-status-${c.id}`}>SIREN {c.siren}</span>;
  }
  if (e?.status === "not_found") {
    return <span className="text-xs px-2 py-0.5 rounded-full border bg-amber-50 text-amber-700 border-amber-200" data-testid={`enrich-status-${c.id}`}>Non trouvée</span>;
  }
  return <span className="text-xs text-zinc-400">—</span>;
}

function ClientsTable({ clients, isLoading }) {
  return (
    <div className="border border-zinc-200 bg-white rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-zinc-50 border-b border-zinc-200">
          <tr className="text-left text-[10px] uppercase tracking-[0.18em] text-zinc-500">
            <th className="px-4 py-3">Raison sociale</th>
            <th className="px-4 py-3">Forme</th>
            <th className="px-4 py-3">Pays</th>
            <th className="px-4 py-3">Référentiel</th>
            <th className="px-4 py-3">Secteur</th>
            <th className="px-4 py-3">Contact</th>
            <th className="px-4 py-3">Annuaire INSEE</th>
            <th className="px-4 py-3 text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-zinc-100">
          {isLoading && <tr><td colSpan={8} className="p-6 text-zinc-500">Chargement…</td></tr>}
          {!isLoading && clients.length === 0 && <tr><td colSpan={8} className="p-6 text-zinc-500">Aucun client. Créez le premier.</td></tr>}
          {clients.map((c) => (
            <tr key={c.id} data-testid={`client-row-${c.id}`} className="hover:bg-zinc-50">
              <td className="px-4 py-3 font-medium">{c.name}</td>
              <td className="px-4 py-3">{c.legal_form || "—"}</td>
              <td className="px-4 py-3">{c.country}</td>
              <td className="px-4 py-3">{c.referentiel}</td>
              <td className="px-4 py-3">{c.sector || "—"}</td>
              <td className="px-4 py-3 text-zinc-600">{c.contact_name || "—"}</td>
              <td className="px-4 py-3"><EnrichBadge c={c} /></td>
              <td className="px-4 py-3 text-right">
                <div className="flex justify-end gap-1">
                  <ClientFormDialog client={c} />
                  <EnrichDialog client={c} onDone={() => mutate("/clients")} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Clients() {
  const { data: clients = [], isLoading } = useSWR("/clients", fetcher);

  return (
    <div>
      <PageHeader
        eyebrow="Portefeuille"
        title="Clients"
        description="Fiche client, dossier permanent, référentiel comptable applicable."
        actions={<ClientFormDialog />}
      />
      <ClientsTable clients={clients} isLoading={isLoading} />
    </div>
  );
}
